// extracted by mini-css-extract-plugin
export var buttonBase = "link-module--button-base--a9b37";
export var cv = "link-module--cv--3a615";
export var normal = "link-module--normal--35532";